const StartIcon = (props) => {
  const { color = 'currentColor' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_2_983"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2_983)">
        <path
          d="M2.91667 14.7917V5.20833H4.00001V14.7917H2.91667ZM13.3798 13.7035L12.6138 12.9375L15.0096 10.5417H5.66021V9.45833H15.0017L12.6138 7.06249L13.3798 6.29645L17.0833 10L13.3798 13.7035Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default StartIcon;
